<!-- @format -->

<ng-container *transloco="let t">
  @for (prerequisiteGroup of prerequisites; track prerequisiteGroup; let prerequisiteIndex = $index) {
    <div class="prerequisite-group-container">
      <div class="grouping-panel">
        <div role="heading" class="sis-mb-xxs sis-label" [attr.aria-level]="level">
          {{ t("STUDIES.PREREQUISITES_EDITOR.PREREQUISITE_CHOICE") }} {{ prerequisiteIndex + 1 }}
        </div>
        @for (prerequisite of prerequisiteGroup.prerequisites; track prerequisite) {
          <div class="prerequisites">
            @if (isCourseUnitPrerequisite(prerequisite)) {
              <sis-course-unit-box [courseUnit]="courseUnitsByGroupId[prerequisite.courseUnitGroupId]" />
            } @else if (isModulePrerequisite(prerequisite)) {
              <sis-module-box [module]="modulesByGroupId[prerequisite.moduleGroupId]" />
            }
          </div>
        }
      </div>
    </div>
  }
  @if (prerequisites?.length === 0) {
    <div class="sis-placeholder">
      <sis-icon icon="alert-fill-attention"></sis-icon>
      {{ t("SIS_COMPONENTS.COURSE_UNIT_REALISATION_INFO.NO_INFORMATION_GIVEN") }}
    </div>
  }
</ng-container>
